import React, { useEffect } from 'react'
import { PhoneInput } from '@paypalcorp/pp-react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'

const PhoneInputAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const handleChange = (event) => {
    input.onChange(event.target.value)
  }
  const handleFocus = () => {
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <PhoneInput
      {...input}
      {...rest}
      onChange={handleChange}
      onFocus={handleFocus}
      errorText={meta.touched ? meta.error : ''}
    />
  )
}

export default PhoneInputAdapter
